import * as React from 'react';
import { ReactNode } from 'react';
import { ExternalIdDTO } from '../../../api/core';
import { ExternalIdData, ExternalIdsData } from '../../../Settings/externs/data';
import { CustomBadge } from '../../components/CustomBadge';
import { ExternalIdEntityType } from '../../../util/types';

interface Props {
  id: ExternalIdDTO;
  entity: ExternalIdEntityType;
}

const parseId = (id: string, type?: 'raw' | 'uri' | 'alnum'): string => {
  switch (type) {
    case 'alnum':
      return id.trim().replace(/[^A-Za-z0-9]/g, '');
    case 'uri':
      return encodeURIComponent(id.trim());
    default:
      return id.trim();
  }
};

export const ExternalId = (props: Props): ReactNode => {
  props.id.type = props.id.type === 'researcher' ? 'wos' : props.id.type;
  const data: ExternalIdData = ExternalIdsData[props.id.type];
  return (
    <div className={'flex py-1'}><CustomBadge
      label={`${!data?.icon ? `${props.id.type}: ` : ''}${props.id.externalId}`}
      externalLink={data?.urls[props.entity] ? data.urls[props.entity](parseId(props.id.externalId, data.id)) : undefined}
      images={data?.icon ? <img src={data.icon} alt={`${data.icon} Logo`}
                               style={{height: '1.5rem', width: '1.5rem', marginLeft: '-0.5rem', borderRadius: 0}}/> : undefined}
      alt={props.id.type}
    /></div>
  );
};
